export default {
  label: {
    aggregationText: 'Total de ',
    aggregationTextAvgSAC: 'Tempo Médio de Captura',
    notShowClassifiedLabel: 'Mostrar não classificados',
    showClassifiedLabel: 'Esconder não classificados',
    filter: {
      button_filter: 'Aplicar Filtro',
    },
    viewTags: {
      button_viewTags: 'Visualizar tags',
    },
  },
  aggregationType: {
    listening: 'publicações',
    sac: 'interações',
    'sac-listening': 'publicações + interações',
    default: 'publicações',
  },
};
